import { useQuery } from 'react-query';
import { fetchHeartRatePhysicalExamination } from '@higo/api/lib/services';
import { useExaminationApiContext } from '@higo/common/src/features/ExaminationPage/providers';
import { ExaminationQueryKey } from '@higo/common/src/features/ExaminationPage/ExaminationQueryKey';

export const useHeartRatePhysicalExaminationQuery = (
  examinationId: number,
  enabled = !isNaN(examinationId),
) => {
  const axios = useExaminationApiContext();

  return useQuery(
    [ExaminationQueryKey.HeartRatePhysicalExamination, examinationId],
    async () => fetchHeartRatePhysicalExamination(axios)(examinationId),
    {
      enabled,
    },
  );
};
